// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"400":"72797efa","602":"52f08de9"}[chunkId] + ".chunk.js";
};